module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/dane-dc957a00.png";